<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row>
      <p class="bonusRuleTopic">{{ $t("rewardRulesTabOne.rewardRules") }}</p>
      <!-- <p class="bonusRuleDesc">
        {{ $t("rewardRulesTabOne.rewardDescription") }}
      </p> -->
    </van-row>
    <van-row style="padding-top: 15px">
      <van-swipe id="bonusIndicator" :loop="false">
        <!-- ========================== 1st swipe ================= -->
        <van-swipe-item>
          <van-row>
            <p class="heading">{{ $t("rewardRulesTabOne.signInReward") }}</p>
          </van-row>
          <van-row style="padding-bottom: 40px">
            <van-col span="24">
              <div class="outerContainer">
                <!-- ----------- A------------ -->
                <van-row class="itemRow">
                  <van-col span="22">
                    <p class="signTopic">
                      {{ $t("rewardRulesTabOne.dailyReward") }}
                    </p>
                  </van-col>
                  <van-col span="2"
                    ><div>
                      <img
                        src="../images/bonus/A.png"
                        style="height: 24px; width: auto"
                      /></div
                  ></van-col>
                </van-row>
                <div class="innerContainer">
                  <van-row style="padding: 15px 0px">
                    <van-col span="8" style="text-align: left">
                      <p class="values">
                        2USDT<span class="timePeriods"
                          >/{{ $t("rewardRulesTabOne.day") }}</span
                        >
                      </p>
                      <p class="levels">
                        {{ $t("rewardRulesTabOne.amateur") }}
                      </p>
                    </van-col>
                    <van-col span="8" style="text-align: left">
                      <p class="values">
                        4USDT<span class="timePeriods"
                          >/{{ $t("rewardRulesTabOne.day") }}</span
                        >
                      </p>
                      <p class="levels">{{ $t("rewardRulesTabOne.rookie") }}</p>
                    </van-col>
                    <van-col span="8" style="text-align: left">
                      <p class="values">
                        8USDT<span class="timePeriods"
                          >/{{ $t("rewardRulesTabOne.day") }}</span
                        >
                      </p>
                      <p class="levels">
                        {{ $t("rewardRulesTabOne.proffessional") }}
                      </p>
                    </van-col>
                  </van-row>
                </div>
                <!-- ----------- B------------ -->
                <van-row class="itemRow" style="margin-top: 5px">
                  <van-col span="22">
                    <p class="signTopic">
                      {{ $t("rewardRulesTabOne.weeklyReward") }}
                    </p>
                  </van-col>
                  <van-col span="2"
                    ><div>
                      <img
                        src="../images/bonus/B.png"
                        style="height: 24px; width: auto"
                      /></div
                  ></van-col>
                </van-row>
                <div class="innerContainer">
                  <van-row style="padding: 15px 0px">
                    <van-col span="8" style="text-align: left">
                      <p class="values">
                        14USDT<span class="timePeriods"
                          >/{{ $t("rewardRulesTabOne.week") }}</span
                        >
                      </p>
                      <p class="levels">
                        {{ $t("rewardRulesTabOne.amateur") }}
                      </p>
                    </van-col>
                    <van-col span="8" style="text-align: left">
                      <p class="values">
                        28USDT<span class="timePeriods"
                          >/{{ $t("rewardRulesTabOne.week") }}</span
                        >
                      </p>
                      <p class="levels">{{ $t("rewardRulesTabOne.rookie") }}</p>
                    </van-col>
                    <van-col span="8" style="text-align: left">
                      <p class="values">
                        56USDT<span class="timePeriods"
                          >/{{ $t("rewardRulesTabOne.week") }}</span
                        >
                      </p>
                      <p class="levels">
                        {{ $t("rewardRulesTabOne.proffessional") }}
                      </p>
                    </van-col>
                  </van-row>
                </div>
                <!-- ----------- C------------ -->
                <van-row class="itemRow" style="margin-top: 5px">
                  <van-col span="22">
                    <p class="signTopic">
                      {{ $t("rewardRulesTabOne.reimbursement") }}
                    </p>
                  </van-col>
                  <van-col span="2"
                    ><div>
                      <img
                        src="../images/bonus/C.png"
                        style="height: 24px; width: auto"
                      /></div
                  ></van-col>
                </van-row>
                <div class="contentBox">
                  <div class="contentBoxBG">
                    <img
                      src="../images/bonus/crown.png"
                      style="height: 25px; width: auto"
                    />
                    <div style="padding: 5px 15px">
                      <p class="ruleTopItem">
                        {{ $t("rewardRulesTabOne.amateur") }}
                      </p>
                      <p class="ruleTopItemDesc" style="font-weight: 700">
                        {{ $t("rewardRulesTabOne.amateurDesc") }}
                      </p>
                      <p class="ruleTopItemDesc">
                        {{
                          $t("rewardRulesTabOne.fullReimbursement")
                        }}:56USDT=14+14+28
                      </p>
                    </div>
                  </div>
                  <div class="contentBoxBG">
                    <img
                      src="../images/bonus/crown.png"
                      style="height: 25px; width: auto"
                    />
                    <div style="padding: 5px 15px">
                      <p class="ruleTopItem">
                        {{ $t("rewardRulesTabOne.rookie") }}
                      </p>
                      <p class="ruleTopItemDesc" style="font-weight: 700">
                        {{ $t("rewardRulesTabOne.rookieDesc") }}
                      </p>
                      <p class="ruleTopItemDesc">
                        {{
                          $t("rewardRulesTabOne.fullReimbursement")
                        }}:168USDT=28+28+56*2
                      </p>
                    </div>
                  </div>
                  <div class="contentBoxBG">
                    <img
                      src="../images/bonus/crown.png"
                      style="height: 25px; width: auto"
                    />
                    <div style="padding: 5px 15px">
                      <p class="ruleTopItem">
                        {{ $t("rewardRulesTabOne.proffessional") }}
                      </p>
                      <p class="ruleTopItemDesc" style="font-weight: 700">
                        {{ $t("rewardRulesTabOne.proffessionalDesc") }}
                      </p>
                      <p class="ruleTopItemDesc">
                        {{
                          $t("rewardRulesTabOne.fullReimbursement")
                        }}:448USDT=56+56+112*3
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </van-col>
          </van-row>
        </van-swipe-item>
        <!-- ========================== 2nd swipe ================= -->
        <van-swipe-item>
          <van-row>
            <p class="heading">{{ $t("rewardRulesTabTwo.agentRebate") }}</p>
          </van-row>
          <!-- ----------- Beginner --------- -->
          <van-row
            v-for="item in userLevels"
            :key="item.id"
            v-if="item.bonus_page_top == 1"
          >
            <div class="rebateBg">
              <van-row class="itemAll">
                <van-col span="5">
                  <img
                    src="../images/bonus/crown.png"
                    style="height: 45px; width: auto"
                  />
                </van-col>
                <van-col span="19">
                  <van-row>
                    <van-col span="24"
                      ><p class="rebateLevel">
                        {{ item[lang] }}
                      </p></van-col
                    >
                  </van-row>
                  <van-row>
                    <van-col span="24">
                      <p class="rebateAmount">
                        {{ $t("rewardRulesTabTwo.deposit") }}
                        {{ item.min_downline_deposit }}
                        <span style="color: #ff0000"
                          >({{ item.comission_rate * 100 }} %
                          {{ $t("rewardRulesTabTwo.commission") }})</span
                        >
                      </p>
                      <!-- <p class="rebateDesc">Downline Investment</p> --></van-col
                    >

                    <!-- <van-col span="8">
                      <p class="rebateAmount" style="color: #ff0000">
                        8% Commission
                      </p>
                      <p class="rebateDesc">Commission</p>
                    </van-col> -->
                  </van-row>
                </van-col>
              </van-row>
            </div>
          </van-row>
          <!-- ----------- Amateur --------- -->
          <!-- <van-row>
            <div class="rebateBg">
              <van-row class="itemAll">
                <van-col span="5">
                  <img
                    src="../images/bonus/crown.png"
                    style="height: 45px; width: auto"
                  />
                </van-col>
                <van-col span="19">
                  <van-row>
                    <van-col span="24"
                      ><p class="rebateLevel">{{ $t("rewardRulesTabTwo.amateur") }}</p></van-col
                    >
                  </van-row>
                  <van-row>
                    <van-col span="24">
                      <p class="rebateAmount">
                        {{ $t("rewardRulesTabTwo.deposit") }} 60,000
                        <span style="color: #ff0000">(10% {{ $t("rewardRulesTabTwo.commission") }})</span>
                      </p> -->
          <!-- <p class="rebateDesc">Downline Investment</p> </van-col
                    >-->

          <!-- <van-col span="8">
                      <p class="rebateAmount" style="color: #ff0000">
                        8% Commission
                      </p>
                      <p class="rebateDesc">Commission</p>
                    </van-col> -->
          <!-- </van-row>
                </van-col>
              </van-row>
            </div>
          </van-row> -->
          <!-- ----------------Rookie -------------- -->
          <!-- <van-row>
            <div class="rebateBg">
              <van-row class="itemAll">
                <van-col span="5">
                  <img
                    src="../images/bonus/crown.png"
                    style="height: 45px; width: auto"
                  />
                </van-col>
                <van-col span="19">
                  <van-row>
                    <van-col span="24"
                      ><p class="rebateLevel">{{ $t("rewardRulesTabTwo.rookie") }}</p></van-col
                    >
                  </van-row>
                  <van-row>
                    <van-col span="24">
                      <p class="rebateAmount">
                        {{ $t("rewardRulesTabTwo.deposit") }} 180,000
                        <span style="color: #ff0000">(12% {{ $t("rewardRulesTabTwo.commission") }})</span>
                      </p> -->
          <!-- <p class="rebateDesc">Downline Investment</p> -->
          <!-- </van-col> -->
          <!-- <van-col span="8">
                      <p class="rebateAmount" style="color: #ff0000">10%</p>
                      <p class="rebateDesc">Commission</p></van-col
                    > -->
          <!-- </van-row>
                </van-col>
              </van-row>
            </div>
          </van-row> -->
          <!-- ----------------Professional -------------- -->
          <!-- <van-row>
            <div class="rebateBg">
              <van-row class="itemAll">
                <van-col span="5">
                  <img
                    src="../images/bonus/crown.png"
                    style="height: 45px; width: auto"
                  />
                </van-col>
                <van-col span="19">
                  <van-row>
                    <van-col span="24"
                      ><p class="rebateLevel">{{ $t("rewardRulesTabTwo.proffessional") }}</p></van-col
                    >
                  </van-row>
                  <van-row>
                    <van-col span="24"> -->
          <!-- <p class="rebateAmount">≥ 180000U</p>
                      <p class="rebateDesc">Downline Investment</p> -->
          <!-- <p class="rebateAmount">
                        {{ $t("rewardRulesTabTwo.deposit") }}
                        <span style="color: #ff0000">(15% {{ $t("rewardRulesTabTwo.commission") }})</span>
                      </p>
                    </van-col> -->
          <!-- <van-col span="8">
                      <p class="rebateAmount" style="color: #ff0000">12%</p>
                      <p class="rebateDesc">Commission</p></van-col
                    > -->
          <!-- </van-row>
                </van-col>
              </van-row>
            </div>
          </van-row>-->
        </van-swipe-item>
        <!-- ========================== 3rd swipe ================= -->
        <van-swipe-item>
          <van-row>
            <p class="heading">{{ $t("rewardRulesTabThree.revenue") }}</p>
          </van-row>
          <van-row>
            <p class="heading" style="font-size: 15px; font-weight: unset">
              {{ $t("rewardRulesTabThree.revenueContent") }}
            </p>
          </van-row>
          <div class="thirdSwipeBody">
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.totalInvestemnt") }} = $10,000
            </p>
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.monthProfit") }}
            </p>
          </div>
          <div class="thirdSwipeBody">
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellTwoHundred") }}
            </p>
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellTwoHundredReward") }}
            </p>
          </div>
          <div class="thirdSwipeBody">
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellThreeHundred") }}
            </p>
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellThreeHundredReward") }}
            </p>
          </div>
          <div class="thirdSwipeBody">
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellFourHundred") }}
            </p>
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellFourHundredReward") }}
            </p>
          </div>
          <div class="thirdSwipeBody">
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellFiveHundred") }}
            </p>
            <p class="thirdSwipeContent">
              {{ $t("rewardRulesTabThree.sellFiveHundredReward") }}
            </p>
          </div>
          <!-- <div class="outerContainer">
            <div class="padding: 10px;">
              <table>
                <tr>
                  <td>Box office receipts</td>
                  <td style="width: 25%; font-weight: 700">Earnings ratio</td>
                  <td style="font-weight: 700">Additional Benefits</td>
                </tr>
                <tr>
                  <td>&#60;200 million</td>
                  <td style="width: 25%">Monthly dividends only</td>
                  <td>2%</td>
                </tr>
                <tr>
                  <td>2 Billion USD</td>
                  <td style="width: 25%">5%</td>
                  <td rowspan="4" class="rowAll">
                    2% of the investment amount of any investment monthly
                    dividend as additional income
                  </td>
                </tr>
                <tr>
                  <td>3 Billion USD</td>
                  <td style="width: 25%">40%</td>
                </tr>
                <tr>
                  <td>4 Billion USD</td>
                  <td style="width: 25%">75%</td>
                </tr>
                <tr>
                  <td>5 Billion USD</td>
                  <td style="width: 25%">110%</td>
                </tr>
              </table>
            </div>
          </div> -->
        </van-swipe-item>
      </van-swipe>
    </van-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Icon, Col, Row, Swipe, SwipeItem } from "vant";
import Fetch from "../../utils/fetch";
Vue.use(Icon).use(Row).use(Col).use(Swipe).use(SwipeItem);

export default {
  name: "bonusrules",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      userLevels: [],
    };
  },
  mounted() {
    this.getUserLevels();
  },
  methods: {
    getUserLevels() {
      Fetch("/User/user_level")
        .then((res) => {
          this.userLevels = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/detailed_screen.png");
  background-size: 100% 100%;
  padding-bottom: 80px;
}

.bonusRuleTopic {
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  padding: 30px 10px 15px;
}
.bonusRuleDesc {
  color: #ffffff;
  font-size: 12px;
  padding: 0px 10px;
}

.heading {
  color: #000000;
  font-size: 26px;
  font-weight: 700;
  padding: 0px 10px 5px;
}

.outerContainer {
  background-image: linear-gradient(#f2d627, #e29218);
  margin: 10px 10px 0px;
  border-radius: 10px;
  padding: 8px;
}

.innerContainer {
  background: url("../images/bonus/bonusRules.png");
  background-size: 100% 100%;
  padding: 0px 10px;
}

.signTopic {
  color: #000000;
  font-size: 16px;
  padding: 10px 0px;
  padding-right: 6px;
  word-break: break-word;
}

.itemRow {
  align-items: center;
  display: flex;
}

.values {
  font-size: 16px;
  color: #ff0000;
  font-weight: 700;
}

.timePeriods {
  font-size: 12px;
}

.levels {
  font-size: 11px;
  color: #000000;
  padding-top: 10px;
  padding-bottom: 5px;
}

.contentBox {
  background: url("../images/bonus/contentBox.png");
  background-size: 100% 100%;
  padding: 10px;
}

.contentBoxBG {
  display: flex;
  align-items: center;
  padding: 0px 5px 5px;
}

.ruleTopItem {
  color: #000000;
  font-size: 10px;
  padding-top: 5px;
}

.ruleTopItemDesc {
  color: #000000;
  font-size: 12px;
  padding-top: 5px;
}

.rebateBg {
  background: url("../images/bonus/rebateBg.png");
  background-size: 100% 100%;
  padding: 35px 25px;
  margin: 0px 5px;
}

.itemAll {
  display: flex;
  align-items: center;
}

.rebateLevel {
  color: rgb(0, 0, 0);
  font-size: 22px;
  font-weight: 700;
}

.rebateAmount {
  color: rgb(0, 0, 0);
  font-size: 16px;
  font-weight: 700;
  padding-top: 15px;
}

.rebateDesc {
  color: rgb(0, 0, 0);
  font-size: 12px;
  padding-top: 5px;
}

// -------- table style -------
// table {
//   border-collapse: separate;
//   border-spacing: 0;
//   width: 100%;
//   border: 1px solid #000000;
//   border-radius: 10px;
// }

// tr td {
//   border-bottom: 1px solid #000000;
//   border-left: 1px solid #000000;
//   padding: 10px;
//   word-break: break-word;
//   font-size: 14px;
// }

// table tr:last-child td:first-child {
//   border-bottom: unset;
// }

// table tr:last-child td:last-child {
//   border-bottom: unset;
// }

// table td:last-child {
//   border-right: unset;
// }

// table td:first-child {
//   border-left: unset;
//   font-weight: 700;
//   width: 25%;
// }

// table td.rowAll {
//   border-bottom: unset;
//   border-left: 1px solid #000000;
// }

.thirdSwipeBody {
  padding: 10px 6px;
  border: 1px solid #ffffff;
  border-radius: 15px;
  margin: 5px;
  background: #ebebeb1f;
}

.thirdSwipeContent {
  color: #ffffff;
  font-size: 14px;
  text-align: justify;
  padding: 4px 0px;
  word-break: break-word;
}
</style>
<style>
#bonusIndicator .van-swipe__indicator {
  background-color: #ffffff;
}

#bonusIndicator .van-swipe__indicator--active {
  background-color: #f3da2f;
}

#bonusIndicator .van-swipe__indicators {
  bottom: 4px;
}
</style>
